(function(){
  var btn=document.querySelector('[data-menu-toggle]');
  var drawer=document.querySelector('[data-menu-drawer]');
  if(btn&&drawer){
    btn.addEventListener('click',function(){
      drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',drawer.classList.contains('is-open')?'true':'false');
    });
  }
  document.querySelectorAll('[data-gallery]').forEach(function(root){
    var main=root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){
      thumb.addEventListener('click',function(){
        if(main&&thumb.dataset.src){main.src=thumb.dataset.src;main.srcset=thumb.dataset.srcset||'';}
      });
    });
  });
})();
